import { render, staticRenderFns } from "./SingleInputBox.vue?vue&type=template&id=876b406e&scoped=true"
import script from "./SingleInputBox.vue?vue&type=script&lang=js"
export * from "./SingleInputBox.vue?vue&type=script&lang=js"
import style0 from "./SingleInputBox.vue?vue&type=style&index=0&id=876b406e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876b406e",
  null
  
)

export default component.exports